var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.994,
    height: 24.059,
    viewBox: "0 0 23.994 24.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tag",
    d: "M27.4,16.112,15.17,3.971H4.029L4,15.1,16.081,27.427a2.017,2.017,0,0,0,2.853.023l8.484-8.485a2.018,2.018,0,0,0-.023-2.853ZM6.982,9a2,2,0,1,1,2,2,2,2,0,0,1-2-2ZM17.863,22.952l-7.778-7.778.707-.707,7.778,7.778-.707.707Zm2.121-2.121-7.778-7.778.708-.707,7.777,7.778-.707.707ZM22.1,18.709l-7.777-7.778.707-.707L22.812,18l-.707.707Z",
    transform: "translate(-4.003 -3.971)",
    fill: "#2bc7c9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.0a0a3e0f06cbfae9ee031a0ea86d77aa.svg";
export { ForwardRef as ReactComponent };